/**
* @file 资源管理-司机资源-创建司机
* */
<template>
    <div class="dataPage">
        <div class="dataPage-content">
            <div name="formII">
                <div class="formTitle flex" style="justify-content: space-between;">
                    <span>详细信息</span>
                    <el-button type="primary" :loading="loadingII" v-show="!editII"
                        @click="formEdit(true, 'formII', 'editII', 'temporaryFormII')">
                        编辑
                    </el-button>
                </div>

                <div class="blueInfo">
                    <p>* 如已开通监管对接服务，则信息必填</p>
                </div>

                <el-form :model="formII" :rules="rulesII" ref="formII" :disabled="!editII" label-position="left"
                    label-width="150px">
                    <el-row>
                        <el-col :span="11">
                            <el-form-item label="性别" prop="driverGender">
                                <el-radio-group v-model="formII.driverGender" size="mini">
                                    <el-radio :label="1">男</el-radio>
                                    <el-radio :label="2">女</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col :span="11" :push="2">
                            <el-form-item label="状态" prop="driverStatus">
                                <el-radio-group v-model="formII.driverStatus" size="mini">
                                    <el-radio label="ZG">在岗</el-radio>
                                    <el-radio label="LZ">离职</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="11">
                            <el-form-item label="民族" prop="nation">
                                <el-input v-model="formII.nation" maxlength="32"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="11" :push="2">
                            <el-form-item label="外语能力" prop="foreignLanguageLevel">
                                <el-input v-model="formII.foreignLanguageLevel" maxlength="64"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="11">
                            <el-form-item label="学历" prop="driverEducation">
                                <el-select v-model="formII.driverEducation" filterable>
                                    <el-option v-for="(item, i) in $const.DRIVEREDUCATION" :key="i" :value="item.value"
                                        :label="item.label">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="11" :push="2">
                            <el-form-item label="手机型号" prop="mobileModel">
                                <el-input v-model="formII.mobileModel" maxlength="32"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="11">
                            <el-form-item label="婚姻状况" prop="maritalStatus">
                                <el-radio-group v-model="formII.maritalStatus" size="mini">
                                    <el-radio :label="0">未婚</el-radio>
                                    <el-radio :label="1">已婚</el-radio>
                                    <el-radio :label="2">保密</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col :span="11" :push="2">
                            <el-form-item label="手机运营商" prop="mobileOperators">
                                <el-select v-model="formII.mobileOperators" filterable>
                                    <el-option v-for="(item, i) in $const.MOBILEOPERATORS" :key="i" :value="item.value"
                                        :label="item.label">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="11">
                            <el-form-item label="出生日期" prop="driverBirthday">
                                <el-date-picker v-model="formII.driverBirthday" size="mini" type="date">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="11" :push="2">
                            <el-form-item label="紧急联系人姓名" prop="emergency">
                                <el-input v-model="formII.emergency" maxlength="64"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="11">
                            <el-form-item label="机动车驾驶证号" prop="motorNo">
                                <el-input v-model="formII.motorNo" maxlength="32"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="11" :push="2">
                            <el-form-item label="紧急联系人电话" prop="emergencyPhone">
                                <el-input v-model="formII.emergencyPhone" maxlength="32"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="11">
                            <el-form-item label="驾驶员通信地址" prop="driverContactAddress">
                                <el-input v-model="formII.driverContactAddress" maxlength="256"
                                    type="textarea"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="11" :push="2">
                            <el-form-item label="紧急联系人地址" prop="emergencyAddress">
                                <el-input v-model="formII.emergencyAddress" maxlength="256" type="textarea"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="11">
                            <el-form-item label="户口登记机关名称" prop="householdRegistrationName">
                                <el-input v-model="formII.householdRegistrationName" maxlength="256"
                                    type="textarea"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="11" :push="2">
                            <el-form-item label="户口住址或长住地址" prop="driverAddress">
                                <el-input v-model="formII.driverAddress" maxlength="256" type="textarea"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row style="text-align: right">
                        <el-button v-show="editII" type="primary" @click="formSave('formII')" :loading="loadingII">
                            保存
                        </el-button>
                        <el-button v-show="editII" @click="formEdit(false, 'formII', 'editII', 'temporaryFormII')"
                            :loading="loadingII">
                            取消
                        </el-button>
                    </el-row>
                </el-form>
            </div>

            <div name="formIII">
                <div class="formTitle flex" style="justify-content: space-between;">
                    <span>证件信息</span>
                    <el-button type="primary" :loading="loadingIII" v-show="!editIII"
                        @click="formEdit(true, 'formIII', 'editIII', 'temporaryFormIII')">
                        编辑
                    </el-button>
                </div>

                <div class="blueInfo">
                    <p>* 如已开通监管对接服务，则信息必填</p>
                </div>

                <el-form :model="formIII" :rules="rulesIII" ref="formIII" :disabled="!editIII" label-position="left"
                    label-width="240px">
                    <el-row>
                        <el-col :span="11">
                            <el-form-item label="驾照类型" prop="driverType">
                                <el-select v-model="formIII.driverType" filterable>
                                    <el-option v-for="(item, i) in $const.DRIVERTYPE" :key="i" :value="item.value"
                                        :label="item.label">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="11" :push="2">
                            <el-form-item :label="`${mixinUserInfo.platformType == 1 ? '网约车' : ''}从业资格证起始时间`"
                                prop="netCarQualificationsStart">
                                <el-date-picker v-model="formIII.netCarQualificationsStart" size="mini" type="date">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="11">
                            <el-form-item label="驾驶员发证机构" prop="licenseOrganization">
                                <el-input v-model="formIII.licenseOrganization" maxlength="128"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="11" :push="2">
                            <el-form-item :label="`${mixinUserInfo.platformType == 1 ? '网约车' : ''}从业资格证到期时间`"
                                prop="netCarQualificationsEnd">
                                <el-date-picker v-model="formIII.netCarQualificationsEnd" size="mini" type="date">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="11">
                            <el-form-item label="驾驶证有效期限起" prop="driveLicenceStart">
                                <el-date-picker v-model="formIII.driveLicenceStart" size="mini" type="date">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="11" :push="2">
                            <el-form-item :label="`${mixinUserInfo.platformType == 1 ? '网络预约出租车' : ''}驾驶员领证日期`"
                                prop="networkTaximanLicenseDate">
                                <el-date-picker v-model="formIII.networkTaximanLicenseDate" size="mini" type="date">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="11">
                            <el-form-item label="驾驶证有效期限止" prop="driveLicenceEnd">
                                <el-date-picker v-model="formIII.driveLicenceEnd" size="mini" type="date">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col v-if="mixinUserInfo.platformType == 1" :span="11" :push="2">
                            <el-form-item label="网络预约出租汽车驾驶员资格证号" prop="networkTaximanNo">
                                <el-input v-model="formIII.networkTaximanNo" maxlength="128"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="11">
                            <el-form-item label="初次领取驾驶证日期" prop="licensingTime">
                                <el-date-picker v-model="formIII.licensingTime" size="mini" type="date">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col v-if="mixinUserInfo.platformType == 1" :span="11" :push="2">
                            <el-form-item label="是否巡游出租汽车驾驶员" prop="isCruisingTaxiDriver">
                                <el-radio-group v-model="formIII.isCruisingTaxiDriver" size="mini">
                                    <el-radio :label="1">是</el-radio>
                                    <el-radio :label="2">否</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row style="text-align: right">
                        <el-button v-show="editIII" type="primary" @click="formSave('formIII')" :loading="loadingIII">
                            保存
                        </el-button>
                        <el-button v-show="editIII" @click="formEdit(false, 'formIII', 'editIII', 'temporaryFormIII')"
                            :loading="loadingIII">
                            取消
                        </el-button>
                    </el-row>
                </el-form>
            </div>

            <div name="formIIII">
                <div class="formTitle flex" style="justify-content: space-between;">
                    <span>合同信息</span>
                    <el-button type="primary" :loading="loadingIIII" v-show="!editIIII"
                        @click="formEdit(true, 'formIIII', 'editIIII', 'temporaryFormIIII')">
                        编辑
                    </el-button>
                </div>

                <div class="blueInfo">
                    <p>* 如已开通监管对接服务，则信息必填</p>
                </div>

                <el-form :model="formIIII" :rules="rulesIIII" ref="formIIII" :disabled="!editIIII" label-position="left"
                    label-width="180px">
                    <el-row>
                        <el-col :span="11">
                            <el-form-item label="合同状态" prop="contractStatus">
                                <el-radio-group v-model="formIIII.contractStatus" size="mini">
                                    <el-radio label="YX">有效</el-radio>
                                    <el-radio label="WX">无效</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col :span="11" :push="2">
                            <el-form-item label="合同审核结果" prop="censorResult">
                                <el-radio-group v-model="formIIII.censorResult" size="mini">
                                    <el-radio label="TG">通过</el-radio>
                                    <el-radio label="BTG">不通过</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="11">
                            <el-form-item label="合同上传扫描件类型" prop="contractType">
                                <el-radio-group v-model="formIIII.contractType" size="mini">
                                    <el-radio label="TG">合同</el-radio>
                                    <el-radio label="BTG">协议</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col :span="11" :push="2">
                            <el-form-item label="合同（或协议）有效期起" prop="contractStart">
                                <el-date-picker v-model="formIIII.contractStart" size="mini" type="date">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="11">
                            <el-form-item label="合同上传扫描件" prop="contractPhoto" class="custom-form-center">
                                <up-img :disabled="!editIIII" :file.sync="formIIII.contractPhoto" width="120"
                                    height="80"></up-img>
                            </el-form-item>
                        </el-col>
                        <el-col :span="11" :push="2">
                            <el-form-item label="合同（或协议）有效期止" prop="contractEnd">
                                <el-date-picker v-model="formIIII.contractEnd" size="mini" type="date">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row style="text-align: right">
                        <el-button v-show="editIIII" type="primary" @click="formSave('formIIII')"
                            :loading="loadingIIII">
                            保存
                        </el-button>
                        <el-button v-show="editIIII" @click="
                            formEdit(false, 'formIIII', 'editIIII', 'temporaryFormIIII')
                            " :loading="loadingIIII">
                            取消
                        </el-button>
                    </el-row>
                </el-form>
            </div>

            <div name="training">
                <div class="formTitle flex" style="justify-content: space-between;">
                    <span>培训信息</span>
                </div>
                <div class="blueInfo">
                    <p>* 如已开通监管对接服务，则信息必填</p>
                    <p>* 培训信息请在培训计划中创建</p>
                </div>

                <el-table style="margin-bottom: 20px" border empty-text="暂无数据" v-loading="loadingTraining"
                    :data="trainingRows">
                    <el-table-column v-for="(item, index) in trainingColumns" :key="index" :show-overflow-tooltip="true"
                        :prop="item.prop" :label="item.label">
                    </el-table-column>

                    <el-table-column fixed="right" label="培训类型" width="100">
                        <template slot-scope="scope">
                            {{
                                scope.row.type == "GQ"
                                    ? "岗前"
                                    : scope.row.type == "RC"
                                        ? "日常"
                                        : "安全培训"
                            }}
                        </template>
                    </el-table-column>

                    <el-table-column fixed="right" label="照片" width="100">
                        <template slot-scope="scope">
                            <div>
                                <el-button v-if="scope.row.photo != null && scope.row.photo != ''"
                                    @click="view(scope.row)" type="text" size="small">查看
                                </el-button>
                                <span v-else>-</span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <br /><br />
            </div>

            <div name="Punishment">
                <!-- 模态框 -->
                <el-dialog :visible.sync="punishmentVisible" @close="$refs.formPunishment.resetFields()" width="400px"
                    title="处罚信息">
                    <el-form :model="formPunishment" :rules="rulesPunishment" ref="formPunishment" label-position="left"
                        label-width="120px">
                        <el-form-item label="处罚原因" prop="punishReason">
                            <el-input type="textarea" v-model="formPunishment.punishReason" maxlength="100">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="处罚结果" prop="punishResult" class="white">
                            <el-input type="textarea" v-model="formPunishment.punishResult" maxlength="100">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="处罚时间" prop="punishTime">
                            <el-date-picker v-model="formPunishment.punishTime" size="mini" type="datetime">
                            </el-date-picker>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button type="primary" size="medium" :loading="loadingPunishment" @click="formSave('formPunishment')">
                            保存
                        </el-button>
                    </div>
                </el-dialog>

                <div class="formTitle flex" style="justify-content: space-between;">
                    <span>处罚信息</span>
                </div>
                <el-table style="margin-bottom: 20px" border empty-text="暂无数据" v-loading="loadingPunishmentRows"
                    :data="punishmentRows">
                    <el-table-column v-for="(item, index) in punishmentColumns" :key="index"
                        :show-overflow-tooltip="true" :prop="item.prop" :label="item.label">
                    </el-table-column>

                    <el-table-column fixed="right" label="操作" width="100">
                        <template slot-scope="scope">
                            <el-button @click="edit(scope.row)" type="text" size="small">编辑
                            </el-button>
                            <el-button type="text" size="small" @click="removePunishment(scope.row)">删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-button style="
            border: 1px #dcdfe6 dashed;
            width: 100%;
          " @click="punishmentAdd">添加处罚信息
                </el-button>
                <br /><br />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "driverForm",
    data() {
        let netCarQualificationsStartValidate = (rule, value, callback) => {
            let netCarQualificationsEnd = Date.parse(
                new Date(this.formIII.netCarQualificationsEnd)
            );
            value = Date.parse(new Date(value));
            if (!value) {
                callback(new Error("起始时间不能为空"));
            } else if (netCarQualificationsEnd && netCarQualificationsEnd <= value) {
                callback(new Error("不能大于或等于到期时间"));
            } else {
                callback();
            }
        };
        let netCarQualificationsEndValidate = (rule, value, callback) => {
            let netCarQualificationsStart = Date.parse(
                new Date(this.formIII.netCarQualificationsStart)
            );
            value = Date.parse(new Date(value));
            if (!value) {
                callback(new Error("到期时间不能为空"));
            } else if (
                netCarQualificationsStart &&
                value <= netCarQualificationsStart
            ) {
                callback(new Error("不能小于或等于起始时间"));
            } else {
                callback();
            }
        };

        let driveLicenceStartValidate = (rule, value, callback) => {
            let driveLicenceEnd = Date.parse(new Date(this.formIII.driveLicenceEnd));
            value = Date.parse(new Date(value));
            if (!value) {
                callback(new Error("起始时间不能为空"));
            } else if (driveLicenceEnd && driveLicenceEnd <= value) {
                callback(new Error("不能大于或等于到期时间"));
            } else {
                callback();
            }
        };

        let driveLicenceEndValidate = (rule, value, callback) => {
            let driveLicenceStart = Date.parse(
                new Date(this.formIII.driveLicenceStart)
            );
            value = Date.parse(new Date(value));
            if (!value) {
                callback(new Error("到期时间不能为空"));
            } else if (driveLicenceStart && value <= driveLicenceStart) {
                callback(new Error("不能小于或等于起始时间"));
            } else {
                callback();
            }
        };

        let contractStartValidate = (rule, value, callback) => {
            let contractEnd = Date.parse(new Date(this.formIIII.contractEnd));
            value = Date.parse(new Date(value));
            if (!value) {
                callback(new Error("起始时间不能为空"));
            } else if (contractEnd && contractEnd <= value) {
                callback(new Error("不能大于或等于到期时间"));
            } else {
                callback();
            }
        };
        let contractEndValidate = (rule, value, callback) => {
            let contractStart = Date.parse(new Date(this.formIIII.contractStart));
            value = Date.parse(new Date(value));
            if (!value) {
                callback(new Error("到期时间不能为空"));
            } else if (contractStart && value <= contractStart) {
                callback(new Error("不能小于或等于起始时间"));
            } else {
                callback();
            }
        };

        return {
            flag: true,
            // 司机id
            id: this.$route.query.id,

            // 培训信息
            trainingColumns: [
                { prop: "organizationName", label: "培训机构名称" },
                { prop: "courseName", label: "培训内容" },
                { prop: "courseDate", label: "培训课程日期" },
                { prop: "startTime", label: "开始时间" },
                { prop: "stopTime", label: "结束时间" },
            ],
            trainingRows: [],
            loadingTraining: false,

            // 基本信息表单
            editI: false,
            temporaryFormI: null,

            // 详细信息表单
            editII: false,
            temporaryFormII: null,
            formII: {
                driverGender: null,
                driverStatus: null,
                nation: null,
                foreignLanguageLevel: null,
                driverEducation: null,
                mobileModel: null,
                maritalStatus: null,
                mobileOperators: null,
                driverBirthday: null,
                emergency: null,
                motorNo: null,
                emergencyPhone: null,
                driverContactAddress: null,
                emergencyAddress: null,
                householdRegistrationName: null,
                driverAddress: null,
            },
            rulesII: {
                driverGender: [{ required: true, message: "请选择性别" }],
                driverStatus: [{ required: true, message: "请选择状态" }],
                nation: [{ required: true, message: "请输入民族" }],
                foreignLanguageLevel: [{ required: true, message: "请输入外语能力" }],
                driverEducation: [{ required: true, message: "请选择学历" }],
                mobileModel: [{ required: true, message: "请输入手机型号" }],
                maritalStatus: [{ required: true, message: "请选择婚姻状况" }],
                mobileOperators: [{ required: true, message: "请选择手机运营商" }],
                driverBirthday: [{ required: true, message: "请选择出生日期" }],
                emergency: [{ required: true, message: "请输入紧急联系人姓名" }],
                motorNo: [{ required: true, message: "请输入机动车驾驶证号" }],
                emergencyPhone: [{ required: true, message: "请输入紧急联系人电话" }],
                driverContactAddress: [
                    { required: true, message: "请输入驾驶员通信地址" },
                ],
                emergencyAddress: [{ required: true, message: "请输入紧急联系人地址" }],
                householdRegistrationName: [
                    { required: true, message: "请输入户口登记机关名称" },
                ],
                driverAddress: [
                    { required: true, message: "请输入户口住址或长住地址" },
                ],
            },

            // 证件信息表单
            editIII: false,
            temporaryFormIII: null,
            formIII: {
                driverType: null,
                netCarQualificationsStart: null,
                licenseOrganization: null,
                netCarQualificationsEnd: null,
                driveLicenceStart: null,
                networkTaximanLicenseDate: null,
                driveLicenceEnd: null,
                networkTaximanNo: null,
                licensingTime: null,
                isCruisingTaxiDriver: null,
            },
            rulesIII: {
                driverType: [{ required: true, message: "请选择驾照类型" }],
                netCarQualificationsStart: [
                    { required: true, validator: netCarQualificationsStartValidate },
                ],
                licenseOrganization: [
                    { required: true, message: "请填写驾驶员发证机构" },
                ],
                netCarQualificationsEnd: [
                    { required: true, validator: netCarQualificationsEndValidate },
                ],
                driveLicenceStart: [
                    { required: true, validator: driveLicenceStartValidate },
                ],
                networkTaximanLicenseDate: [
                    { required: true, message: "请选择驾驶员领证日期" },
                ],
                driveLicenceEnd: [
                    { required: true, validator: driveLicenceEndValidate },
                ],
                networkTaximanNo: [
                    { required: true, message: "请填写网络预约出租汽车驾驶员资格证号" },
                ],
                licensingTime: [
                    { required: true, message: "请选择初次领取驾驶证日期" },
                ],
                isCruisingTaxiDriver: [
                    { required: true, message: "请选择是否巡游出租汽车驾驶员" },
                ],
            },

            // 合同信息表单
            editIIII: false,
            temporaryFormIIII: null,
            formIIII: {
                contractStatus: null,
                censorResult: null,
                contractPhoto: null,
                contractType: null,
                contractStart: null,
                contractEnd: null,
            },
            rulesIIII: {
                contractStatus: [{ required: true, message: "请选择合同状态" }],
                censorResult: [{ required: true, message: "请选择合同审核结果" }],
                contractPhoto: [{ required: true, message: "请上传合同扫描件" }],
                contractType: [{ required: true, message: "请选择合同上传扫描件类型" }],
                contractStart: [{ required: true, validator: contractStartValidate }],
                contractEnd: [{ required: true, validator: contractEndValidate }],
            },

            // 处罚信息
            punishmentVisible: false,
            formPunishment: {
                punishmentMoney: undefined,
            },
            rulesPunishment: {
                punishReason: [{ required: true, message: "请输入处罚原因" }],
                punishResult: [{ required: true, message: "请输入处罚结果" }],
                punishTime: [{ required: true, message: "请选择处罚时间" }],
            },
            punishmentColumns: [
                { prop: "punishReason", label: "处罚原因" },
                { prop: "punishResult", label: "处罚结果" },
                { prop: "punishTime", label: "处罚时间" },
            ],
            punishmentRows: [],

            // 保存按钮loading
            loadingI: false,
            loadingII: false,
            loadingIII: false,
            loadingIIII: false,
            loadingPunishment: false,
            loadingPunishmentRows: false,
        };
    },
    watch: {
    },
    async created() {
        this.getInfo();
    },
    methods: {
        // type:编辑或者取消 formName:表单form editNumber:编辑下标 temporaryForm:临时form对象
        formEdit(type, formName, editNumber, temporaryForm) {
            if (editNumber != "editI" && !this.id) {
                this.$message.warning("请先完善【基本信息】并保存后，再进行操作");
                return;
            }
            if (type) {
                this[temporaryForm] = JSON.parse(JSON.stringify(this[formName]));
                this[editNumber] = true;
            } else {
                this.$refs[formName].resetFields();
                this[formName] = JSON.parse(JSON.stringify(this[temporaryForm]));
                this[editNumber] = false;
            }
        },
        edit(row) {
            this.punishmentVisible = true;
            this.$nextTick(() => {
                this.formPunishment = JSON.parse(JSON.stringify(row));
            });
        },
        // 添加处罚信息事件
        punishmentAdd() {
            if (!this.id) {
                this.$message.warning("请先完善【基本信息】并保存后，再进行操作");
            } else {
                this.punishmentVisible = true;
            }
        },
        //删除处罚信息
        async removePunishment(row) {
            let insuranceURL = "/api/v1/manage/driver/supervise/punishment/" + row.id;
            let res = await this.$axios.delete(insuranceURL);
            if (res && res.code === 1) {
                this.$message.success("已删除");
                this.getPunishmentRows();
            }
        },
        /**
         * 点击保存
         */
        async formSave(formName) {
            switch (formName) {

                case "formII":
                    this.$refs.formII.validate((valid) => {
                        if (valid) {
                            this.postSupervise();
                        } else {
                            this.$message.warning("请检查表单数据是否输入正确！");
                        }
                    });

                    break;
                case "formIII":
                    this.$refs.formIII.validate((valid) => {
                        if (valid) {
                            this.postIdentity();
                        } else {
                            this.$message.warning("请检查表单数据是否输入正确！");
                        }
                    });

                    break;
                case "formIIII":
                    this.$refs.formIIII.validate((valid) => {
                        if (valid) {
                            this.postContract();
                        } else {
                            this.$message.warning("请检查表单数据是否输入正确！");
                        }
                    });

                    break;
                case "formPunishment":
                    this.$refs.formPunishment.validate((valid) => {
                        if (valid) {
                            this.postPunishment();
                        } else {
                            this.$message.warning("请检查表单数据是否输入正确！");
                        }
                    });

                    break;
                default:
                    break;
            }
        },


        // 详细信息操作
        async postSupervise() {
            this.loadingII = true;
            let url = "/api/v1/manage/driver/supervise/info";
            let params = this.$utils.deepCopyFn({
                ...this.formII,
                driverBirthday: Date.parse(new Date(this.formII.driverBirthday)),
                driverId: this.id,
            });
            let data = await this.$axios.post(url, params);
            if (data && data.code === 1) {
                this.$message.success("保存成功！");
                this.formII.id = data.data;
                this.editII = false;
            }
            this.loadingII = false;
        },

        // 证件信息操作
        async postIdentity() {
            this.loadingIII = true;
            let url = "/api/v1/manage/driver/supervise/identity/info";
            let params = this.$utils.deepCopyFn({
                ...this.formIII,
                netCarQualificationsStart: Date.parse(
                    new Date(this.formIII.netCarQualificationsStart)
                ),
                netCarQualificationsEnd: Date.parse(
                    new Date(this.formIII.netCarQualificationsEnd)
                ),
                driveLicenceStart: Date.parse(new Date(this.formIII.driveLicenceStart)),
                driveLicenceEnd: Date.parse(new Date(this.formIII.driveLicenceEnd)),
                networkTaximanLicenseDate: Date.parse(
                    new Date(this.formIII.networkTaximanLicenseDate)
                ),
                licensingTime: Date.parse(new Date(this.formIII.licensingTime)),
                driverId: this.id,
            });
            let data = await this.$axios.post(url, params);
            if (data && data.code === 1) {
                this.$message.success("保存成功！");
                this.formIII.id = data.data;
                this.editIII = false;
            }
            this.loadingIII = false;
        },

        // 合同信息操作
        async postContract() {
            this.loadingIIII = true;
            let url = "/api/v1/manage/driver/supervise/contract/info";
            let params = this.$utils.deepCopyFn({
                ...this.formIIII,
                contractStart: Date.parse(new Date(this.formIIII.contractStart)),
                contractEnd: Date.parse(new Date(this.formIIII.contractEnd)),
                driverId: this.id,
            });
            let data = await this.$axios.post(url, params);
            if (data && data.code === 1) {
                this.$message.success("保存成功！");
                this.formIIII.id = data.data;
                this.editIIII = false;
            }
            this.loadingIIII = false;
        },

        /**
         * 处罚信息操作
         */
        async postPunishment() {
            this.loadingPunishment = true;
            let url = "/api/v1/manage/driver/supervise/punishment";
            let params = this.$utils.deepCopyFn({
                ...this.formPunishment,
                punishTime: Date.parse(new Date(this.formPunishment.punishTime)),
                driverId: this.id,
            });
            let data = await this.$axios.post(url, params);
            if (data && data.code === 1) {
                this.$message.success("保存成功！");
                this.punishmentVisible = false;
                this.getPunishmentRows();
            }
            this.loadingPunishment = false;
        },

        // 获取详情
        async getInfo() {
            if (!this.id) {
                return false;
            } else {
                this.flag = false;
            }


            let formIIURL = "/api/v1/manage/driver/supervise/info/" + this.id;
            let dataII = await this.$axios.get(formIIURL);
            if (dataII && dataII.code === 1) {
                this.formII = dataII.data || {};
            }

            let formIIIURL =
                "/api/v1/manage/driver/supervise/identity/info/" + this.id;
            let dataIII = await this.$axios.get(formIIIURL);
            if (dataIII && dataIII.code === 1) {
                this.formIII = dataIII.data || {};
            }

            let formIIIIURL =
                "/api/v1/manage/driver/supervise/contract/info/" + this.id;
            let dataIIII = await this.$axios.get(formIIIIURL);
            if (dataIIII && dataIIII.code === 1) {
                this.formIIII = dataIIII.data || {};
            }
            this.getTrainingRows();
            this.getPunishmentRows();
        },
        async view(row) {
            this.$utils.largeImgFn(row.photo)
        },
        //获取培训计划列表
        async getTrainingRows() {
            this.loadingTraining = true;
            let trainingURL = "/api/v1/manage/driver/supervise/train";
            let params = {
                driverId: this.id,
            };
            let res = await this.$axios.get(trainingURL, params);
            if (res && res.code === 1) {
                res.data.forEach((item) => {
                    item.courseDate = this.$utils.timeFn(item.courseDate, "YYYY/MM/DD");
                    item.startTime = this.$utils.timeFn(
                        item.startTime,
                        "YYYY/MM/DD HH:mm:SS"
                    );
                    item.stopTime = this.$utils.timeFn(
                        item.stopTime,
                        "YYYY/MM/DD HH:mm:SS"
                    );
                    item.startTime = item.startTime.substring(11, 16);
                    item.stopTime = item.stopTime.substring(11, 16);
                });
                this.trainingRows = res.data || [];
            }
            this.loadingTraining = false;
        },
        //获取处罚信息列表
        async getPunishmentRows() {
            this.loadingPunishmentRows = true;
            let punishmentURL =
                "/api/v1/manage/driver/supervise/punishment/" + this.id;
            let res = await this.$axios.get(punishmentURL);
            if (res && res.code === 1) {
                res.data.forEach((item) => {
                    item.punishTime = this.$utils.timeFn(
                        item.punishTime,
                        "YYYY/MM/DD HH:mm:SS"
                    );
                });
                this.punishmentRows = res.data || [];
            }
            this.loadingPunishmentRows = false;
        },

    },
};
</script>

<style lang="less" scoped>
.dataPage {
    &-content {
        width: 1100px;
    }
}

</style>
